import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import StickyList from '../views/StickyList.vue';
import Login from '../views/user/Login.vue';

import FollowList from '../views/FollowList.vue'
import FansList from '../views/FansList.vue'
import UserProfile from '../views/UserProfile.vue'
import OtherUsers from '../views/OtherUsers.vue'
import Messages from '../views/Messages.vue'
import EditPersonalInformation from '../views/user/EditPersonalInformation.vue'
import Postreport from '../views/posts/Postreport.vue'
import PostDetails from '../views/posts/PostDetails.vue'
import NotFound from '../views/NotFound.vue'

import Sidebar from '../components/Sidebar.vue'
import SearchUser from '../components/SearchUser.vue'

// import store from '@/store'; // 假设 store 位于 src/store/index.js

import { createStore } from '../store/index.js'
const store = createStore()

Vue.use(VueRouter);

// 添加新页面得路由配置要同步到sitemap_router的文件

const routes = [
	{
		path: '/',
		name: 'home',
		title: 'TOZO Community home',
		component: Home
	},
	{
		path: '/posts-list',
		name: 'posts-list',
		title: 'TOZO Community home',
		component: Home
	},
	{
		path: '/sticky-list',
		name: 'sticky-list',
		title: 'TOZO Community Sticky List',
		component: StickyList
	},
	{
		path: '/login',
		name: 'login',
		title: 'TOZO Community Login',
		component: Login
	},
	
	// 需要登录的页面
	// 关注列表
	{
		path: '/follow-list',
		name: 'follow-list',
		title: 'TOZO Community follow list',
		component: FollowList
	},
	// 粉丝列表
	{
		path: '/fans-list',
		name: 'fans-list',
		title: 'TOZO Community fan home',
		component: FansList
	},
	// 个人用户信息
	{
		path: '/user-profile',
		name: 'user-profile',
		title: 'TOZO Community Users profile',
		component: UserProfile
	},
	// 消息
	{
		path: '/messages',
		name: 'messages',
		title: 'TOZO Community messages',
		component: Messages
	},
	// 编辑个人信息
	{
		path: '/edit-personal-information',
		name: 'edit-personal-information',
		title: 'TOZO Community Edit Personal Information',
		component: EditPersonalInformation
	},
	// 其他用户信息
	{
		path: '/home/users-:user_id',
		name: 'search-user',
		title: 'TOZO Community Users Homepage',
		component: OtherUsers
	},
	// 其他用户信息
	{
		path: '/:previous/users-:user_id',
		name: 'users',
		title: 'TOZO Community Users Homepage',
		component: OtherUsers
	},
	//举报帖子
	{
		path: '/:previous/report-:post_id',
		name: 'post-report',
		title: 'TOZO Community Post report',
		component: Postreport
	},
	//用户列表 举报帖子
	{
		path: '/:previous/:user/report-:post_id',
		name: 'user-post-report',
		title: 'TOZO Community Post report',
		component: Postreport
	},
	//帖子详情
	{
		path: '/:previous/details-:post_id',
		name: 'post-details',
		title: 'TOZO Community Post Details',
		component: PostDetails
	},
	//用户列表 帖子详情
	{
		path: '/:previous/:user/details-:post_id',
		name: 'user-post-details',
		title: 'TOZO Community Post Details',
		component: PostDetails
	},
  // {
  //   path: '/Sidebar',
  //   name: 'Sidebar',
  //   component: Sidebar
  // },
  // {
  //   path: '/search-user',
  //   name: 'SearchUser',
  //   component: SearchUser
  // }
	{
		path: '*',
		name: 'not-found',
		component: NotFound
	},
];

const createRouter = () => new VueRouter({
	mode: 'history', // require service support
	scrollBehavior: () => ({y: 0}),
	routes: routes
})

const router = createRouter()

export function resetRouter() {
	const newRouter = createRouter()
	router.matcher  = newRouter.matcher // reset router
}

// const router = new VueRouter({
//   mode: 'history',
//   routes
// })

// 路由守卫：限制未登录用户访问受保护页面
// router.beforeEach((to, from, next) => {
// 	// const isAuthenticated = store.state.access_token;
// 	const isAuthenticated = true;
// 	if (['/login'].includes(to.path)) {
// 		next(); // 登录和注册页面直接放行
// 	} else if (!isAuthenticated) {
// 		next('/login'); // 未登录用户跳转到登录页面
// 	}else if (to.meta.keepAlive) {
//     // 这里可以根据需要做更多处理，比如根据路由参数判断是否缓存
//     // 比如： if (to.params.someParam) {
//     //          to.meta.keepAlive = false;
//     //        }
//     next();
//   } else {
//     next();
//   }
// });

// 全局前置守卫
const pageStates = {};
router.beforeEach((to, from, next) => {
	console.log(to)
	console.log( from)
	store.state.pageNameList.to = to;
	store.state.pageNameList.from = from;
    console.log('即将跳转的路由参数:', to.params);
   // 模拟登录状态
   const isAuthenticated = true;

   // 路由守卫：未登录跳转到登录页面
   if (['/login'].includes(to.path)) {
      next();
   } else if (!isAuthenticated) {
      next('/login');
   }else{
		next();
	}

   // 保存离开页面的状态
   if (from.name) {
      const fromComponent = from.matched[0].instances.default;
		console.log(fromComponent)
      if (fromComponent) {
			// console.log(store)
			// console.log(store.state.pageStates)
         pageStates[from.name] = {
            scrollTop: document.querySelector('.Content-layout')?.scrollTop || window.scrollY,
            data: fromComponent.$data
         };
			console.log(pageStates[from.name])
      }
   }
});

router.afterEach((to) => {
   if (to.name && pageStates[to.name]) {
      const toComponent = to.matched[0].instances.default;
      if (toComponent) {
         // 恢复滚动位置
			Vue.nextTick(() => {
				// 恢复组件的数据状态
				Object.assign(toComponent.$data, pageStates[to.name].data);
				const scrollToTop = () => {
					const targetScrollTop = pageStates[to.name].scrollTop || 0; // 目标滚动位置
					window.scrollTo(0, targetScrollTop); // 直接滚动到目标位置，无需平滑
				};
				scrollToTop();
			});
      }
   }
});


const originalPush = router.push;
router.push = function push(location) {
   return originalPush.call(this, location).catch(err => {
      if (err.name === 'NavigationDuplicated') {
         return Promise.resolve();
      }
      throw err;
   });
};

// 页面路由
export default router
